var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 72,
    viewBox: "0 0 137 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3593 54.8224L73.5793 46.4061L43.8303 17.442L18.1664 43.7424H0L44.2211 0.269043L90.6077 46.7421L65.3593 72.0001V54.8224Z",
    fill: "#0770B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5488 36.1331L65.5517 44.3837L59.4846 50.109L65.3563 54.8237V71.999L41.6738 50.2772L56.5488 36.1331Z",
    fill: "#7EE553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6426 22.3251L92.7595 0.266972L136.601 43.8783H118.986L92.3678 18.2838L79.8414 30.7444L70.6426 22.3251Z",
    fill: "#7EE553"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ee066eb812d275db79fe52343d830aa.svg";
export { ForwardRef as ReactComponent };